<div class="unauthenticated">
    <dr-card [padding]="'none'" [appearance]="'outlined'" class="unauthenticated__card">
        <div class="unauthenticated__content">
            <h1 class="unauthenticated__title">You're not authenticated</h1>
            <p class="unauthenticated__subtitle">
                Sign up to try your data with FinanceOS and unlock your personalized AI agents.
            </p>
            <dr-button [theme]="'primary'" [type]="'button'" (click)="handleSignUp()"> Sign Up </dr-button>
        </div>
    </dr-card>
</div>
